{
	"title": "Esqueceu a senha?",
	"subtitle": "Informe o e-mail cadastrado na sua conta.",
	"description": "Vamos enviar um link para você redefinir sua senha",
	"labels": {
		"company": "Empresa",
		"email": "E-mail"
	},
	"fields": {
		"organization": {
			"placeholder": "Insira a empresa",
			"required": "A empresa é obrigatória"
		},
		"email": {
			"placeholder": "Insira seu e-mail",
			"required": "O e-mail é obrigatório",
			"invalid": "E-mail inválido"
		}
	},
	"submit": "Enviar",
	"submitWait": "Reenviar em {{time}}",
	"back": "Voltar",
	"successModal": {
		"title": "Solicitação enviada!",
		"subtitle": "Se os dados informados estiverem corretos, enviaremos um link de redefinição para o e-mail cadastrado.",
		"btnTitle": "Entendi"
	}
}
